import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AdministrationComponent } from './components/administration/administration.component';
import { AdministrationIoComponent } from './components/administration/components/administration-io/administration-io.component';
// tslint:disable-next-line:max-line-length
import { AdministrationMaintenanceComponent } from './components/administration/components/administration-maintenance/administration-maintenance.component';
import { MarketwebsiteListComponent } from './components/marketwebsite-list/marketwebsite-list.component';
import {CommonModule} from '@angular/common';
import {MarketwebsiteMerchantsComponent} from './components/marketwebsite-merchants/marketwebsite-merchants.component';
import {MarketwebsiteMerchantsHelpComponent} from './components/marketwebsite-merchants-help/marketwebsite-merchants-help.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    NgxDatatableModule,
  ],
  declarations: [
    AdministrationComponent,
    AdministrationIoComponent,
    AdministrationMaintenanceComponent,
    MarketwebsiteListComponent,
    MarketwebsiteMerchantsComponent,
    MarketwebsiteMerchantsHelpComponent
  ]
})
export class AdministrationModule { }



// WEBPACK FOOTER //
// ./src/app/administration/administration.module.ts